export default __webpack_public_path__ + "static/media/Smart_TV.4a7aafea.svg";